const DESKTOP_MIN_WIDTH = 1024;
const SEARCH_OPEN_CLASS = 'header-site--search-open';

let destroyHeaderSearch = null;

export const initHeaderSearch = () => {
  destroyHeaderSearch?.();

  const header = document.querySelector('.header-site');
  const searchButton = document.querySelector('.header-site__search-button');
  const searchPanel = document.querySelector('.header-site__search-panel');
  const searchInput = searchPanel?.querySelector('.header-site__search-input');
  const searchPageInput = document.querySelector('.search-page [data-search-page-input]');

  if (!header || !searchButton) {
    return;
  }

  let outsideClickController = null;

  const isDesktop = () => window.innerWidth >= DESKTOP_MIN_WIDTH;
  const isOpen = () => header.classList.contains(SEARCH_OPEN_CLASS);
  const isSearchPage = () => searchPageInput instanceof HTMLInputElement;

  const focusSearchPageInput = () => {
    if (!(searchPageInput instanceof HTMLInputElement)) {
      return;
    }

    const rect = searchPageInput.getBoundingClientRect();
    const isInViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (!isInViewport) {
      searchPageInput.scrollIntoView({ block: 'center', inline: 'nearest' });
    }

    searchPageInput.focus({ preventScroll: true });

    const caretPosition = searchPageInput.value.length;
    searchPageInput.setSelectionRange(caretPosition, caretPosition);
  };

  const detachOutsideClickHandler = () => {
    outsideClickController?.abort();
    outsideClickController = null;
  };

  const attachOutsideClickHandler = () => {
    if (outsideClickController || !isDesktop()) {
      return;
    }

    outsideClickController = new AbortController();

    document.addEventListener(
      'click',
      (event) => {
        if (!isOpen()) {
          return;
        }

        const target = event.target;

        if (!(target instanceof Node)) {
          return;
        }

        if (header.contains(target) || searchPanel?.contains(target)) {
          return;
        }

        closeSearch();
      },
      { capture: true, signal: outsideClickController.signal }
    );
  };

  const closeSearch = () => {
    if (!isOpen()) {
      return;
    }

    header.classList.remove(SEARCH_OPEN_CLASS);
    searchButton.setAttribute('aria-expanded', 'false');
    searchInput?.blur();
    detachOutsideClickHandler();
  };

  const openSearch = () => {
    if (isOpen()) {
      return;
    }

    header.classList.add(SEARCH_OPEN_CLASS);
    searchButton.setAttribute('aria-expanded', 'true');
    attachOutsideClickHandler();

    if (isDesktop()) {
      searchInput?.focus();
    }
  };

  const handleButtonClick = (event) => {
    event.preventDefault();

    if (isDesktop() && isSearchPage()) {
      closeSearch();
      focusSearchPageInput();
      return;
    }

    if (isOpen()) {
      closeSearch();
      return;
    }

    openSearch();
  };

  const handleResize = () => {
    if (!isDesktop()) {
      detachOutsideClickHandler();
      return;
    }

    if (isOpen()) {
      attachOutsideClickHandler();
      return;
    }
  };

  searchButton.addEventListener('click', handleButtonClick);
  window.addEventListener('resize', handleResize);

  handleResize();

  destroyHeaderSearch = () => {
    detachOutsideClickHandler();
    searchButton.removeEventListener('click', handleButtonClick);
    window.removeEventListener('resize', handleResize);
  };
};
